module.exports = __webpack_public_path__ + "img/starbucks.b4c453c0.jpg";